import Buscador from "../components/dashboard/Buscador";
import cotizador from "../components/cotizador/cotizador";

export const routes = [
  { path: "/buscador", Component: Buscador },
  { path: "/cotizador", Component: cotizador },
];
